import { render, staticRenderFns } from "./PriceChart.vue?vue&type=template&id=e9947b90&scoped=true&"
import script from "./PriceChart.vue?vue&type=script&lang=js&"
export * from "./PriceChart.vue?vue&type=script&lang=js&"
import style0 from "./PriceChart.vue?vue&type=style&index=0&id=e9947b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9947b90",
  null
  
)

export default component.exports